<template>
  <div class="box">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"></i>
        部门管理
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div @click="gett()" style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" class="filtrate1">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <button @click="dialogFormVisible = true" class="center_list_head_rig">添加部门</button>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="name" label="部门列表" width="159" align="center"></el-table-column>

        <el-table-column prop="info" label="职位描述" width="140" align="center"></el-table-column>
        <el-table-column prop="people_count" label="成员人数" width="180" align="center"></el-table-column>

        <el-table-column prop="create_date" label="添加时间" width="230" align="center"></el-table-column>
        <el-table-column prop="status" label="禁用/激活" width="90" align="center">
          <template slot-scope="scope">
            <el-switch
              @change="status($event,scope.row.id)"
              v-model="scope.row.status"
              active-color="rgb(19, 206, 102)"
              inactive-color="#dcdfe6"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="260" align="center" name="bianji">
          <template slot-scope="scope">
            <button @click="permiss(scope.row.id)">权限设置</button>
            <button @click="set(scope.row.id)">编辑</button>
            <button @click="del(scope.row.id)">删除</button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <noAccess v-else></noAccess>
    <!-- 添加部门 -->
    <el-dialog title="添加部门" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="form">
        <el-form-item label="部门名称" :label-width="formLabelWidth">
          <el-input style="width:300px" clearable v-model="name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="职位描述" :label-width="formLabelWidth">
          <el-input style="width:300px" clearable v-model="info" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑部门 -->
    <el-dialog title="编辑部门" :visible.sync="dialogFormVisible1" width="600px">
      <el-form :model="form">
        <el-form-item label="部门名称" :label-width="formLabelWidth">
          <el-input style="width:300px" clearable v-model="name1" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="职位描述" :label-width="formLabelWidth">
          <el-input style="width:300px" clearable v-model="info1" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="setSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "leftmenu",
  data() {
    return { serve: this.$store.state.serve,
    role:true,
      id:"",
      username: "",
      token: "",
      router: "",
      name :'',
      info:'',
      name1 :'',
      info1:'',
      menuItems: null,
      style1: {
        height: null
      },
      total: null,
      current_page: null,
      tableData: [],
      options:[],
      group_id: 0,
      page: null,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      formLabelWidth: "120px"
    };
  },
  created() {
    this.gett();
    this.$store.state.leftTitle = '部门管理';
    this.$store.state.topActiveId = 6;
  },

  methods: {
    permiss(id){
      this.$router.push({
        path:'./management/'+id
      })
    },
    set(id){
      this.id = id
      this.dialogFormVisible1 = true
      this.axios.get(this.serve+'/admin/get_admin_group_info',{
        params:{
          username : this.username,
          token : this.token,
          id
        }
      }).then(res=>{
        this.name1 = res.data.data.name;
        this.info1 = res.data.data.info
      })
    },
    setSubmit(){
      this.axios.get(this.serve+'/admin/change_admin_group',{
        params:{
          username : this.username,
          token : this.token ,
          id : this.id,
          info : this.info1,
          name : this.name1
        }
      }).then(res=>{
        if(res.data.status == 'success'){
          this.dialogFormVisible1 = false
          this.$message({
            message:'编辑成功',
            type :'success'
          })
          this.gett()
        }else if(res.data.code == '403'){
          this.$message.error(res.data.msg); 
        }else if(res.data.status == 'error'){
          this.$message.error('编辑失败')
        }
      })
    },
    submit(){
        this.axios.get(this.serve+'/admin/create_admin_group',{
          params:{
            username : this.username,
            token : this.token,
            name: this.name,
            info : this.info
          }
        }).then(res=>{
          if(res.data.status == 'success'){
            this.dialogFormVisible = false
            this.gett()
            this.$message({
              message:'添加成功',
              type : 'success'
            })
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          }else if(res.data.status == 'error'){
            this.$message.error('添加失败')
          }
        })
    },
    gett(page) {
      //获取数据
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      if (this.token === this.token) {
        this.axios
          .get(this.serve+"/admin/get_admin_group", {
            params: {
              page: page,
              username: this.username,
              token: this.token
            }
          })
          .then(res => {
            this.tableData = [];
            var json = res.data;
            if (res.data.status === "success") {
              that.current_page = json.now_page;
              that.page = json.now_page;
              that.total = json.page_num;
              for (var key in json.data) {
                if (key >= 0) {
                  that.tableData.push(json.data[key]);
                }
              }
            }else{
              if(res.data.msg == "无权访问")
              {
                that.role = false
              }
            }
          });
      }
    },
    status(v, id) {
      //禁用激活
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/status_admin_group", {
          params: {
            username: this.username,
            token: this.token,
            id: id
          }
        })

        .then(res => {
          if (res.data.status == "success") {
            if (v == 1) {
              var str = "激活";
            } else {
              var str = "禁用";
            }
            this.$notify({
              title: str + "成功",
              message: "管理员" + str + "成功",
              type: "success"
            });
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          }
        });
    },
    del(id) {
      //删除按钮
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      if (this.token === this.token) {
        this.$confirm("删除后部门所有人员将失去权限, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.axios
              .get(this.serve+"/admin/del_admin_group", {
                params: {
                  id: id,
                  username: this.username,
                  token: this.token
                }
              })
              .then(function(res) {
                if (res.data.status == "success") {
                  that.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                  // that.group(that.options)
                  that.gett();
                }else if(res.data.code == '403'){
                  that.$message.error(res.data.msg); 
                } else {
                  that.$message({
                    type: "error",
                    message: "删除失败!"
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    }
  }
};
</script>

<style lang="scss">
.box {
  background: #f5f5f5;
  min-height: 1000px;
}
.el-pagination {
  text-align: center;
}

.topBar {
  margin-bottom: 40px;
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
}

.filtrate1 {
  width: 1060px;
  height: 100%;
  // margin-left: 420px;
  margin:  0 auto;
  // background: orange;
  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    // background: pink;
    .filtrate_filer {
      height: 46px;
      width: 1044px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .filtrate_seek {
      position: relative;
      font-size: 16px;
      // border-bottom: 1px solid rgba(221, 221, 221, 1);
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 86px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      // margin: 24px 0 0 17px;
      display: flex;
      align-items: center;
      background: #fff;
      > strong {
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
        margin-right: 6px;
      }
      .filtrate_seek_sousuo {
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        position: absolute;
        right: 18px;
        top: 29px;
        cursor: pointer;
      }
    }
    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    background: rgba(238, 238, 238, 1);
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
  }
}
button {
  border: 0;
  border: none;
  outline: none;
  background: none;
  font-size: 14px;
  font-family: "MicrosoftYaHeiLight";
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
  cursor: pointer;
}
button:hover {
  color: #0099ff;
}
// .el-row {
//   display: flex;
//   justify-content: center;
// }
</style>

